import { defineRule } from 'vee-validate'

export const requiredRule = defineRule('requiredRule', (value: string) => {
  return !!value || 'Questo campo è obbligatorio'
})

export const emailRule = defineRule('emailRule', (value: string) => {
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(value) || "L'email inserita non è valida"
})

export const italianPhoneRule = defineRule('italianPhoneRule', (value: string) => {
  if (!value) return true // facoltativo
  const phoneRegex = /^3\d{8,9}$/
  return phoneRegex.test(value) || 'Il numero di telefono non è valido (es. 3201234567)'
})

export const fileRule = defineRule('fileRule', (value: File | null) => {
  if (!value) return true // facoltativo
  const maxSize = 5 * 1024 * 1024 // 5MB
  const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
  if (!allowedTypes.includes(value.type)) return 'Formato non valido. Sono accettati solo PDF, DOC e DOCX'
  if (value.size > maxSize) return 'Il file non può superare i 5MB'
  return true
})